import { atom } from 'jotai';
const LOCALE_PLACEHOLDER = 'locale_placeholder';
export const $Locale = atom({
    region: LOCALE_PLACEHOLDER,
    ipRegion: LOCALE_PLACEHOLDER,
    language: LOCALE_PLACEHOLDER,
});
//# sourceMappingURL=locale.js.map